const GENERIC_ELECTIVE_TOKENS = new Set([
  'ALAN', 'BOLUM', 'FAKULTE', 'MESLEKI', 'ORTAK', 'PROGRAM', 'SERBEST',
  'TEKNIK', 'UNIVERSITE', 'SECMELI', 'DERS', 'DERSI', 'DERSLER', 'DERSLERI',
]);

export function normalizeElectiveName(name) {
  return String(name || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ı/g, 'i')
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, ' ')
    .trim()
    .replace(/\s+/g, ' ');
}

export function isGenericElectivePlaceholder(name) {
  const tokens = normalizeElectiveName(name).split(' ').filter(Boolean);
  if (!tokens.includes('SECMELI')) return false;
  return tokens.every((token) => (
    GENERIC_ELECTIVE_TOKENS.has(token)
    || /^\d+$/.test(token)
    || /^[IVXLCDM]+$/.test(token)
  ));
}
